import {useTranslation} from 'react-i18next';

import {Grid, Typography} from '@mui/material';

import {pdfH3} from '../styles';

import {CulturePillarCard} from './CulturePillarCard';
import {
  innovationConventionImage,
  appearanceRiskImage,
  performanceOrganization,
  purposeValuesImage,
} from '../../../../assets/pdf/culture_pillars';

export const CulturePillarsPageOne = () => {
  const {t} = useTranslation('pdfDomain');
  const {t: tr} = useTranslation('pdfDomain', {keyPrefix: 'analysisGuide.culturePillars.pageOne'});

  const culturePillars = [
    {
      image: innovationConventionImage,
      title: tr('innovationConvention.title'),
      description: tr('innovationConvention.description'),
    },
    {
      image: purposeValuesImage,
      title: tr('purposeValues.title'),
      description: tr('purposeValues.description'),
    },
    {
      image: performanceOrganization,
      title: tr('performanceOrganisation.title'),
      description: tr('performanceOrganisation.description'),
    },
    {
      image: appearanceRiskImage,
      title: tr('appearanceRisk.title'),
      description: tr('appearanceRisk.description'),
    },
  ];

  return (
    <Grid container p={5}>
      <Typography variant='h3' sx={pdfH3} mr={1} mb={2}>
        {t('analysisGuide.culturePillars.sharedTitle')}
      </Typography>
      <Typography variant='h3' sx={pdfH3}>
        1/2
      </Typography>
      <Grid container item alignItems={'center'}>
        {culturePillars.map((pillar, index) => (
          <CulturePillarCard pillar={pillar} index={index} key={pillar.title} />
        ))}
      </Grid>
    </Grid>
  );
};
